import { useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'

import {
  AGE_OPTIONS,
  AGE_QUESTION,
  SECTION_NUMBER,
} from '~/pages/anatomyV2/age/libs/components/AnatomyV2Age/constants'
import { AnatomyV2AgeStyles as S } from '~/pages/anatomyV2/age/libs/components/AnatomyV2Age/styles'
import SectionProgress from '~/pages/anatomyV2/libs/components/SectionProgress'
import { useMatchHeaderBackground } from '~/pages/anatomyV2/libs/hooks/useMatchHeaderBackground'
import { AgeLegalConsent } from '~/shared/components/AgeLegalConsent'
import { useDelayedContinue } from '~/shared/hooks/useDelayedContinue'
import { useNextStep } from '~/shared/hooks/useNextStep'
import { eventLogger } from '~/shared/services/eventLogger'
import { TPageProps } from '~/shared/types/commonTypes'

const AnatomyV2Age = ({ pageId, nextPagePath }: TPageProps) => {
  useMatchHeaderBackground()

  const { t } = useTranslation('anatomyV2')
  const [answer, setAnswer] = useState('')
  const { isAnswersDisabled, handleChange, setIsAnswersDisabled } =
    useDelayedContinue()

  const handleContinue = useNextStep({
    nextPagePath,
    pageId,
    pageName: pageId,
    question: AGE_QUESTION,
  })

  return (
    <S.Root>
      <S.ContentWrapper>
        <SectionProgress currentSection={SECTION_NUMBER} pageId={pageId} />

        <S.Title>
          <Trans ns="anatomyV2" i18nKey="onboarding.age.title" />
        </S.Title>

        <S.Options>
          {AGE_OPTIONS.map(({ key, i18nKey }) => (
            <S.OptionButton
              key={key}
              type="button"
              $isSelected={answer === key}
              disabled={isAnswersDisabled}
              onClick={() => {
                setAnswer(key)
                eventLogger.logBiUserAge(key, true)
                handleChange(key, handleContinue)
                setIsAnswersDisabled(true)
              }}
            >
              {t(i18nKey)}
            </S.OptionButton>
          ))}

          <AgeLegalConsent />
        </S.Options>
      </S.ContentWrapper>
    </S.Root>
  )
}

export default AnatomyV2Age
